module.exports = __webpack_public_path__ + "img/meshulash_yes.39fec24f.png";